namespace('compass.show');

compass.show.ClosedWidget = compass.defineWidget(function ClosedWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom.getContext(me);

	var _settings = options;
	var _inputs = {};

	var _validator = new compass.validator({});

	var _render = me.render = function (widgetElem) {
		widgetElem.append(
			_drawGenericMessage(),
			_drawCustomMessage(),
			_drawLogin()
		);

		widgetElem.append(
			d.div({
				className: "clearingDiv"
			}, "")
		);
	};

	var _drawGenericMessage = function () {
		return d.div({
			className: 'explanation'
		}, d.h6({
				className: 'title'
			}, "You're too late!"),
			d.p({
				className: 'body'
			}, "Reservations are no longer being taken for this show.")
		);
	};

	var _drawCustomMessage = function () {
		return d.div({
			className: 'customMessage'
		}, _settings.message);
	};

	var _drawLogin = function () {
		return d.div({
			className: 'loginLink'
		},
			"Checking your existing reservation?",
			d.a({
				href: "#"
			}, 'Log in &raquo;').activate(
				function (event) {
					event.preventDefault();
					me.trigger('ClosedWidget.RequestLogin');
					return false;
				}
			)
		);
	};
}, {
	WUID: 'defaultClosingWidgetWUID',
	widgetName: 'closedWidget',
	message: 'Instruction Block here'
});

